module.exports = __webpack_public_path__ + "static/media/landingBg_old.da99ec4e.jpg";